import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavItems.css';

function NavItems() {
  return (
    <>
    <nav className="navbar">
      <ul className="navbar-nav">
        <li className="nav-item">
          <NavLink className="nav-link" to="/?quan76f=1@t.ie">
            Home
          </NavLink>
        </li>
      </ul>
    </nav>
    </>
  );
}

export default NavItems;
